module.exports = __webpack_public_path__ + "statics/img/banner-right.32edef09.png";